import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=fb851f68&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=fb851f68&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb851f68",
  null
  
)

export default component.exports